module.exports = __webpack_public_path__ + "img/large-screen-bg.b3c346fd.png";